// extracted by mini-css-extract-plugin
module.exports = {"block":"subscription-info-header_block__bNJD0","blockLabel":"subscription-info-header_blockLabel__1oKQT"};